export default "__VITE_ASSET__d381b93e__"